<template>
  <div class="edv-crt">
    <div class="edv-crt-itmdtls"
    
    :style="containerStyles" >
      <div
        class="crt-itm"
        v-for="(item, index) in Array.from({ length: modulePropsData.qty })"
        :key="index"
        :style="itemStyles"
      >
        <div class="flx-sb">
          <span class="crt-itm-hdng">{{modulePropsData.headings[index]}}</span>
          <img
            v-if="EdvItems[index]?.name"
            :src="staticImgBaseUrl + '/images/global/delete-button.svg'"
            class="delIconStyle"
            @click="deleteEdvItem(EdvItems[index], index)"
            alt="Delete-Button"
          />
        </div>

        <div class="crt-itm-info">
          <img
            v-if="EdvItems[index]?.image"
            :src="imgBaseUrl + '/' + EdvItems[index]?.image"
            :alt="EdvItems[index]?.name"
            width="40"
            height="40"
          />
          <img
            v-else
            :src="staticImgBaseUrl + '/images/global/edv_pizza_placeholder.png'"
            alt="Edv_Placeholder"
          />

          <div class="crt-itm-dtl">
            <span v-if="EdvItems[index]?.name">{{ EdvItems[index]?.name }}</span>
            <div v-else-if="EdvItems?.length + 1 <= index" class="flx-col">
              <span class="gry-ln" />
              <span class="gry-ln wd3" />
            </div>
            <span
              v-else
              class="crt-itm-dtl-def-txt"
            >
              {{ modulePropsData.selectPizzaText }}
            </span>

            <div class="crt-itm-prc" v-if="EdvItems[index]?.itemPrice">
              <template v-if="checkIfValidStrikePrice(EdvItems[index])">
                  <span 
                    class="fs-14"
                  >
                    <i class="rs">Rs.</i>
                    <span class="slsh-prc">
                      {{ checkIfValidStrikePrice(EdvItems[index]) }}
                    </span>
                  </span>
              </template>  
              <span>
                  <i class="rs">Rs.</i>
                  <span>
                    {{
                      itemIsCustomized(EdvItems[index])
                        ? getTotalCustomisedPriceWithToppings(EdvItems[index])
                        : EdvItems[index]?.itemPrice
                    }}
                  </span>
                </span>
              </div>

          </div>
        </div>
      </div>
    </div>

  
    <div v-if="EdvItems.length" class="edv-crt-ftr">
      <div class="edv-crt-txt">
          <span v-html="GetSavingText"></span>
      </div>

      <button
        class="edv-btn-cta"
        :class="{ disabled: EdvItems.length < modulePropsData.qty }"
        @click="addEdvToCart()"
      >
       <span> {{ modulePropsData.buttonText }} </span>
      </button>
    </div>
  </div>

</template>


<script>
import { imgBaseUrl, staticImgBaseUrl, videoSwitch, v2PwaBasePath } from "../config/apiEndpoints";
import {
  keyMapsMutation,
  keyMapsGetter,
  keyMapsAction,
} from "../helpers/storeKeys";
import setEvents from "../helpers/events";
import PageNames from "../config/pageNames";
import Utility from "../helpers/utility";

export default {
  name: "EdvBottomBar",
  props: ["moduleProps"],
  data() {
    return {
      modulePropsData : {},
      imgBaseUrl: imgBaseUrl,
      staticImgBaseUrl: staticImgBaseUrl,
    };
  },
  async mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    const parsedQtyMap = JSON.parse(this.modulePropsData.qtyMap);
    this.modulePropsData.headings = this.getHeadings(this.modulePropsData.qty, parsedQtyMap);
    this.$store.commit(keyMapsMutation.UPDATE_EDV_MAX_QUANTITY, this.modulePropsData.qty);
  },
  methods: {
    getHeadings(qty, qtyMap) {
      const headingString = qtyMap[qty];
      return headingString ? headingString.split(',') : [];
    },
    edvBottomBarEventFunction(Event, eventAction) {
      const preEventObj = {
        Event_Action: eventAction,
        Event_Category: "EDV Product list",
        screenName: PageNames.NEXTGEN_EDVPAGE,
        previousScreenname: PageNames.NEXTGEN_HOMEPAGE,
      };
      const eventObj = Utility.amplitudeEventObj(
        "EDV Product list",
        "EDV Bottom Bar",
        "-1",
        preEventObj
      );
      setEvents("amplitude", Event, eventObj);
    },
    updateSavingMessage(edvItems) {
      const totalDiscount = edvItems.reduce(
        (sum, item) => sum + (item.discount || 0),
        0
      );
      if (totalDiscount <= 0) return null;

      const messageKey = 
        edvItems.length >= this.modulePropsData.qty 
          ? "savingText" 
          : "savingMessageForAddotherPizza";

      return this.modulePropsData[messageKey].replace(/XX/, totalDiscount);
    },
    getTotalToppingPrice(EdvItem) {
      const addedToppings = EdvItem?.addTopngs;
      let total = 0;
      addedToppings.forEach((i) => {
        total += Number(
          this.showToppingPrice(
            this.toppingFormStore.find(
              (j) => Number(j?.toppingId) === Number(i)
            )?.price
          )
        );
      });
      return total;
    },
    getTotalCustomisedPriceWithToppings(EdvItem) {
        if (EdvItem?.itemPrice === EdvItem?.defaultPrice)
          return Number(EdvItem?.itemPrice) + this.getTotalToppingPrice(EdvItem);
        else return EdvItem?.itemPrice;
    },
    checkIfValidStrikePrice(EdvItem) {
      let itemOriginalPrice;
      let itemFinalPrice;
      let itemSavingPrice;
      const {crustId = "" , sizeId = "" , crust = [] , itemPrice} = EdvItem;
      if(crust.length){
        const {originalPrice = 0 , price = 0  } = crust?.filter(item => item.crustId == crustId)[0]?.sizes?.filter((item) => item.sizeId == sizeId)[0] || {};
        const priceWrtCrustSize = price;
        const toppingPrice = itemPrice - priceWrtCrustSize;

        itemOriginalPrice = originalPrice;
        if(toppingPrice){
          itemOriginalPrice  = itemOriginalPrice + toppingPrice;
        }
        itemFinalPrice = itemPrice;      
      }
      else{ 
        const { defaultPrice = 0, originalPrice = 0 } = EdvItem;
        itemOriginalPrice = originalPrice;
        itemFinalPrice = defaultPrice;
      }
      itemSavingPrice = itemOriginalPrice - itemFinalPrice;
      return itemSavingPrice > 0 ? itemOriginalPrice : false;
    },
    checkItemCustomizedChanges(EdvItem) {
      if (
        EdvItem.defaultSizeName !== EdvItem.sizeName ||
        EdvItem.defaultCrustName !== EdvItem.crustName
      ) {
        return true;
      } else {
        return false;
      }
    },
    checkReplaceToppingChanges(EdvItem) {
      if (EdvItem.repTopngs?.length > 0) {
        return true;
      } else return false;
    },
    itemIsCustomized(EdvItem) {
      if (
        this.checkItemCustomizedChanges(EdvItem) ||
        EdvItem?.addTopngs?.length > 0 ||
        this.checkReplaceToppingChanges(EdvItem)
      ) {
        return true;
      } else {
        return false;
      }
    },
    deleteEdvItem(item, index) {
      this.edvBottomBarEventFunction('edvDelete', `Pizza no. ${index+1} Removed`);
      if(this.EdvPopUpVisible){
        this.$store.commit(keyMapsMutation.UPDATE_EDV_POPUP_STATE, false);
      }
      this.$store.commit(keyMapsMutation.REMOVE_FROM_EDV_ITEMS, item);
    },
    addEdvToCart() {
      this.edvBottomBarEventFunction('EDVProductList', 'EDV Pizzas Added to Cart');
      this.$store.commit(keyMapsMutation.ADD_EDV_ITEMS_TO_CART);
      window.location.href = `${v2PwaBasePath}/cart`;
    },
  },
  computed: {
    EdvItems() {
      const edvItems = this.$store.state.Edv.edvItems || [];
      return edvItems;
    },
    GetSavingText() {
      const savingMessage = this.updateSavingMessage(this.EdvItems);
      return savingMessage;
    },
    containerStyles() {
      return {
        overflowX: this.modulePropsData.qty > 2 ? 'scroll' : 'hidden',
      };
    },
    itemStyles() {
      if (this.modulePropsData.qty === 2) {
        return {
          flex: '0 0 calc(50% - 4.8px)',
        };
      } else if (this.modulePropsData.qty >= 3) {
        return {
          flex: '0 0 calc((100%/2.3) - 6.4px)', 
        };
      }
    },
    EdvPopUpVisible() {
      return this.$store.state.Edv.edvPopUpVisible || false;
    },
  }  
};
</script>
